import React, { useEffect } from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

// import { useParams } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

// End
//validation initialization
const Validation_Schema = Yup.object().shape({
  // profile_pic: Yup.string().required("Required"),
  firstname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  lastname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  contact: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  qualification: Yup.string().required("Required"),
});

function AddGuards(props) {
  // const { egid } = useParams();

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  //variables declration
  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [email, setemail] = React.useState("");
  const [address, setaddress] = React.useState("");
  const [documentsList, setDocumentsList] = React.useState([]);
  const [Update, setUpdate] = React.useState(false);
  const [qualification, setqualification] = React.useState("");
  const [profile_pic, setProfilePic] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);


  //formik intialization
  
  if(props.name>0)
  {
    var formikInitials = {
      profile_pic: profile_pic,
      firstname: firstname,
      lastname: lastname,
      contact: contact,
      email: email,
      address: address,
      qualification: qualification,
    };
  }
  else
  {
     formikInitials = {
      profile_pic: "",
      firstname: "",
      lastname: "",
      contact: "",
      email: "",
      address: "",
      qualification: "",
    };
  }

  
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    if (props.name > 0) {
      viewguarddetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  //view guard details
  async function viewguarddetails() {
    setShowLoader(true);
    let bodyFormData = "";
    await makeGetRequest("guards/getbyid/" + props.name, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          let nm = response.data.data.guard_name.split(" ");
          console.log(response.data.data)
          setfirstname(nm[0]);
          setlastname(nm[1]);
          setProfilePic(response.data.data.guard_profile_pic);
          setcontact(response.data.data.contact_no);
          setemail(response.data.data.email_id);
          setaddress(response.data.data.address);
          setqualification(response.data.data.qualification);
          setDocumentsList(response.data.data.document_list);

        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }
  // add Guards
  async function addguardsfun() {
    alert("IN Add Guards")
    if (props.name > 0) {
      let inputdata = {
        guard_profile_pic: profile_pic,
        guard_id: props.name,
        guard_name: firstname + " " + lastname,
        contact_no: contact,
        email_id: email,
        address: address,
        qualification: qualification,
        document_list: documentsList,
      };
      await makePostRequest("guards/update/web", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Guard Updated Successfully", "success", {
              timer: 3000,
              buttons: false,
            });
            navigate("/Guards");
          } else {
          }
        })
        .catch((err) => {
          swal("There was an error!", err.message, "warning");
        });
    } else {
      let newPass = firstname + "@" + contact.slice(0, 4);

      let inputdata = {
        guard_profile_pic: profile_pic,
        guard_name: firstname + " " + lastname,
        contact_no: contact,
        email_id: email,
        address: address,
        logincode: "",
        language: "English",
        qualification: qualification,
        password: newPass,
        document_list: documentsList,
        society_id: localStorage.getItem("socityid"),
        society_code: localStorage.getItem("societyCode"),
      };
      await makePostRequest("guards/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Guard Added Successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            navigate("/Guards");
          } else {
          }
        })
        .catch((err) => {
          console.log("in catch")
          swal("There was an error!", err, "warning");
        });
    }

    setDocumentErrMsg("");
    setProfileErrMsg("");
  }

  function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function validateImage(fileData) {
    if(fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  const [profileErrMsg, setProfileErrMsg] = React.useState("");
  const [documentErrMsg, setDocumentErrMsg] = React.useState("");

  async function uploadProfilePic(e) {

    setProfileErrMsg("")
    const file = e.target.files[0];
    alert(await validateImage(file));
    if (await validateImage(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      setProfilePic(profilePicUrl);
    } 
    else
     setProfileErrMsg("Invalid File Format");
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;
    setShowLoader(true);
    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    setShowLoader(false);

    return fileUrl;
  }

  async function uploadDocuments(e) {
    // handle validations
    setDocumentErrMsg("");
    const file = e.target.files[0];
    if(await validateImageOrFile(file))
    {
    var profilePicUrl = await uploadImageOrFile(file);

    documentsList.push(profilePicUrl);
    setDocumentsList(documentsList);
    setUpdate(!Update);
    }
    else
    {
      setDocumentErrMsg("Invalid Document Type")
    }
    // document.getElementById("doqumentDiv1").innerHTML.reload();
  }

  async function deleteDocument(index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    setUpdate(!Update);
  }

  useEffect(() => {}, [Update]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Guards")}
              />{" "}
              {props.name > 0 ? <>Edit Guard</> : <>Add Guard</>}
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Guard Details</div>
            <div className="addAgencyMain">
              <Grid item xs={12} md={12}>
                {/* <div className="addSpotsOutBt AssignDutyBt">
                  <Button
                    className="addSpotsBt"
                    onClick={() => navigate("/Agencies")}
                  >
                    Add Guards Through Agency
                  </Button>
                </div> */}
              </Grid>
              <Formik
                enableReinitialize
                initialValues={formikInitials}
                validationSchema={Validation_Schema}
                onSubmit={addguardsfun}
              >
                {({
                  values,
                  handleChange,
                  errors,
                  setFieldTouched,
                  touched,
                  isValid,
                  handleSubmit,
                }) => (
                  <Form>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <div className="tabLeftDiv">
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                              <div className="tabLeftDiv">
                                <div className="uploadImDiv">
                                  <div className="uploadIm">
                                    {profile_pic ? (
                                      <img src={profile_pic} />
                                    ) : (
                                      <img src={defaultProfilePic} />
                                    )}
                                  </div>
                                  <div className="uploadInpu">
                                    <FileUploadIcon />
                                    <span>Upload Profile Photo</span>
                                    <em className="uploadPhotoErrorMsg">
                                              {profileErrMsg}
                                            </em>
                                    <input
                                      type="file"
                                      id="profile_pic"
                                      // value={values.profile_pic}
                                      onChange={(event) =>
                                        uploadProfilePic(event, "resident")
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">First Name</label>
                              <input
                                className="inputSt"
                                placeholder="First Name"
                                value={values.firstname}
                                onChange={handleChange("firstname")}
                                onBlur={() => setFieldTouched("firstname")}
                                onChangeCapture={(e) =>
                                  setfirstname(e.target.value)
                                }
                              />
                              {errors.firstname && touched.firstname ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.firstname}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Last Name</label>
                              <input
                                className="inputSt"
                                placeholder="Last Name"
                                value={values.lastname}
                                onChange={handleChange("lastname")}
                                onBlur={() => setFieldTouched("lastname")}
                                onChangeCapture={(e) =>
                                  setlastname(e.target.value)
                                }
                              />
                              {errors.lastname && touched.lastname ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.lastname}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Contact No.</label>
                              <input
                                className="inputSt"
                                placeholder="Contact No"
                                value={values.contact}
                                maxLength={10}
                                onChange={handleChange("contact")}
                                onBlur={() => setFieldTouched("contact")}
                                onChangeCapture={(e) =>
                                  setcontact(e.target.value)
                                }
                              />
                              {errors.contact && touched.contact ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.contact}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Email ID</label>
                              <input
                                className="inputSt"
                                placeholder="Email ID"
                                value={values.email}
                                onChange={handleChange("email")}
                                onBlur={() => setFieldTouched("email")}
                                onChangeCapture={(e) =>
                                  setemail(e.target.value)
                                }
                              />
                              {errors.email && touched.email ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.email}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <label className="tabsLabel">Address</label>
                              <textarea
                                className="textAriaSt"
                                placeholder="Address"
                                value={values.address}
                                onChange={handleChange("address")}
                                onBlur={() => setFieldTouched("address")}
                                onChangeCapture={(e) =>
                                  setaddress(e.target.value)
                                }
                              ></textarea>
                              {errors.address && touched.address ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.address}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Qualification</label>
                              <input
                                className="inputSt"
                                placeholder="Qualification"
                                value={values.qualification}
                                onChange={handleChange("qualification")}
                                onBlur={() => setFieldTouched("qualification")}
                                onChangeCapture={(e) =>
                                  setqualification(e.target.value)
                                }
                              />
                              {errors.qualification && touched.qualification ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.qualification}
                                </div>
                              ) : null}
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <div className="tabRightDiv">
                          <div className="societyDoc">
                          <h4 className="documeUpload documeUploadIcon">
                            Upload Documents
                            <Button className="forUploadOnly">
                              <FileUploadIcon />
                              <input
                                type="file"
                                style={{
                                  opacity: 0,
                                  position: "absolute",
                                  left: 0,
                                }}
                                id="documentsList"
                                value={values.documentsList}
                                onChange={(event) => uploadDocuments(event)}
                              />
                            </Button>
                          </h4>
                          </div>
                          {documentErrMsg ? (
                                          <div className="errorField errorFieldFForLogin forInvalidFile">
                                            {documentErrMsg}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                          {documentsList.map((option, index) => (
                            <div id="documentDiv" className="doqumentDiv1">
                              <Zoom>
                                <div className="doquView">
                                  {option.split(".").pop() == "txt" ? (
                                    <img src={txtImage} />
                                  ) : option.split(".").pop() == "pdf" ? (
                                    <img src={pdfImage} />
                                  ) : option.split(".").pop() == "docx" ||
                                    option.split(".").pop() == "doc" ? (
                                    <img src={wordImage} />
                                  ) : option.split(".").pop() == "xls" ||
                                    option.split(".").pop() == "xlsx" ? (
                                    <img src={excelImage} />
                                  ) : (
                                    <img src={option} />
                                  )}
                                </div>
                              </Zoom>
                              <span>
                                <a href={option}>
                                  {option.split("/").pop().replace("%20", " ")}
                                </a>
                                <DoneIcon className="doneIcon" />{" "}
                              </span>

                              <Button
                                className="documRemove"
                                onClick={() =>
                                  deleteDocument("resident", index)
                                }
                              >
                                <DeleteForeverIcon className="deleIco" />
                              </Button>
                            </div>
                          ))}
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div
                          className="addOwnerTopLine cancelBtForAllOuter"
                          style={{ textAlign: "center" }}
                        >
                          <Button className="addBt cancelBtForAll" onClick={()=>navigate("/Guards")}>
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            className="addBt"
                            // onClick={() => addguardsfun()}
                            // onClick={handleClickOpen("body")}
                          >
                            {props.name > 0 ? (
                              <div> Update </div>
                            ) : (
                              <div> Add </div>
                            )}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="succesMain">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                    <h4>Success !</h4>
                    <p>Mile Dormon is added successfully.</p>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default AddGuards;
